/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

const useUniversityActivityListSegmented = ({
	universityActivityList
}) => {
	const [universityActivityListSegmented, setUniversityActivityListSegmented] = useState({
		sport: [],
		nonSport: []
	});
	useEffect(() => {
		fillUniversityActivityListSegmented();
	}, [universityActivityList]);
	function fillUniversityActivityListSegmented() {
		const sportUniversityActivityListSegmented = [];
		const nonSportUniversityActivityListSegmented = [];
		universityActivityList.forEach(activity => {
			if (activity.isSport)
				sportUniversityActivityListSegmented.push(activity);
			else nonSportUniversityActivityListSegmented.push(activity);
		});
		setUniversityActivityListSegmented({
			nonSport: nonSportUniversityActivityListSegmented,
			sport: sportUniversityActivityListSegmented
		});
	}

	return universityActivityListSegmented;
}
	
export default useUniversityActivityListSegmented;